// extracted by mini-css-extract-plugin
module.exports = {"container":"ConjugatorPage_container__2HJDH","textAreaContainer":"ConjugatorPage_textAreaContainer__xz6mj","buttonsContainer":"ConjugatorPage_buttonsContainer__3GA5t"};